import React from 'react';
import classes from './Project_Card.css';
import { Badge, Button } from 'react-bootstrap';

let ratingsBadgeColor = null;

const ProjectCard = (props) => {
    

    let styleFront = {

        backgroundImage: 'url('+ props.image +')',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
    }

    let styleBack = {

        backgroundImage: 'url(' + props.image + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        'WebkitFilter': 'blur(3px)'

    }


    let badgeStyles = {

        backgroundColor: 'rgb(4, 146, 77)',
        padding: '4px 10px 4px 10px'
    }
    var isShow = 0

    const calcShow = () => {
        const small_search = props.search.toLowerCase()
        const l = props.tags.length
        for(let i=0;i<l;i++){
            if(props.tags[i].toLowerCase().includes(small_search)){
                isShow=1
            }
        }
    }

    calcShow()

    if(isShow){
        return (
            
            <div className="outerDIV" >

                <div className="flip3D">

                    <div className="front" style={styleFront}>
                    </div>

                    
                    <div className="back" >
                        <div className = "ParaWrapper" >
                            
                            <p className = "title">{props.name}</p>
                            <p className = "stack">
                                {
                                    props.tags.map(function(item,i){
                                        return <Badge key={i} style={badgeStyles}>{item}</Badge>
                                    })
                                }
                                
                            </p>
                            <p className="view">
                                <Button className="zoom">
                                    <a href={props.link} target="_blank">
                                        View Details
                                    </a>
                                </Button>
                            </p>
                        </div>
                        <img className = "img" src = {props.image} alt='null' style = {styleBack} />       
                    </div>
                </div>
            </div>
        );
    }else{
        return(
            <div className="empty">

            </div>
        )
    }
};

let resolveRatingsBadgeColor = (ratings) => {
    
    if (ratings >= 8.0) {

        ratingsBadgeColor = '#00C853';
    } else if (ratings >= 7.0 && ratings < 8.0) {

        ratingsBadgeColor = '#00E676';
    } else if (ratings >= 6.0 && ratings < 7.0) {

        ratingsBadgeColor = '#FFEB3B';
    } else {

        ratingsBadgeColor = '#D32F2F';
    }

    return ratingsBadgeColor;
}

export default ProjectCard;
